module.exports = __webpack_public_path__ + "img/Screenshot-10.7ad0cf1c.png";